<script setup lang="ts">
import {Icon} from '@iconify/vue';

const zoom = defineModel<number>('zoom', {required: true});

function decrease() {
  zoom.value = Math.max(0.5, zoom.value - 0.1);
}

function increase() {
  zoom.value = Math.min(2, zoom.value + 0.1);
}

function reset() {
  zoom.value = 1;
}
</script>

<template>
  <div class="flex items-center gap-1 bg-gray-100/80 p-1 rounded-lg border border-gray-200 text-sm max-w-min">
    <button
        class="btn btn-ghost "
        type="button"
        :disabled="zoom <= 0.5"
        @click="decrease"
        title="Verkleinern"
    >
      <Icon icon="fa6-solid:minus" class="text-xs"/>
    </button>

    <div class="flex shrink items-center gap-1 px-1">
      <input
          type="range"
          min="0.5"
          max="2"
          step="0.1"
          v-model.number="zoom"
          class="max-w-20 shrink min-w-10 inline-flex h-1.5 bg-gray-300 rounded-lg appearance-none cursor-pointer accent-blue-600"
      />
      <span class="text-xs font-mono min-w-max text-right text-gray-600">{{ Math.round(zoom * 100) }}%</span>
    </div>

    <button
        type="button"
        class="btn btn-ghost"
        :disabled="zoom >= 2"
        @click="increase"
        title="Vergrößern"
    >
      <Icon icon="fa6-solid:plus" class="text-xs"/>
    </button>

    <div class="w-px h-4 bg-gray-300 mx-0.5"></div>

    <button
        type="button"
        class="btn btn-ghost"
        @click="reset"
        title="Zoom zurücksetzen"
    >
      <Icon icon="fa6-solid:rotate-right" class="text-xs"/>
    </button>
  </div>
</template>
